export enum CommonRoute {
  NOT_FOUND = 'notFound',
}
